(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationAllergy', EvaluationAllergy);

    EvaluationAllergy.$inject = ['$resource'];

    function EvaluationAllergy ($resource) {
        var resourceUrl =  'api/evaluation-allergies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-allergies/by-evaluation/:id', isArray: true}
        });
    }
})();
